export default function StatCard({ label, value, desc, variant, onClick, active }) {
  const clickable = typeof onClick === 'function';
  const style = clickable
    ? {
        cursor: 'pointer',
        outline: active ? '2px solid var(--ac)' : 'none',
        outlineOffset: -2,
        boxShadow: active ? '0 0 0 2px var(--ac-l)' : undefined,
        transition: 'transform .12s, box-shadow .12s',
        transform: active ? 'translateY(-1px)' : 'none',
        position: 'relative',
      }
    : undefined;
  return (
    <div
      className={`sc${variant ? ' ' + variant : ''}`}
      onClick={clickable ? onClick : undefined}
      style={style}
      title={clickable ? (active ? 'Click to clear filter' : 'Click to filter') : undefined}
    >
      <div className="sc-lb">
        {label}
        {clickable && (
          <span style={{
            marginLeft: 6, fontSize: 9, opacity: active ? 1 : 0.5,
            color: active ? 'var(--ac)' : 'var(--tx3)',
          }}>{active ? '✓ filtered' : '⏷ filter'}</span>
        )}
      </div>
      <div className="sc-vl">{value}</div>
      {desc && <div className="sc-ds">{desc}</div>}
    </div>
  );
}
